<template>
  <div>
    <div class="with-margin">
      <router-link class="back" to="/"
        ><img alt="Back" src="@/assets/images/back.svg"
      /></router-link>
      <h1>Shared Service Center Łódź</h1>
    </div>
    <div class="with-margin tabs">
      <div
        class="flex flex-wrap justify-center floors"
        style="margin-bottom: 89px"
      >
        <a :class="{ selected: this.selectedFloor == 2 }" @click="change(2)"
          >FLOOR 2</a
        >
        <a :class="{ selected: this.selectedFloor == 3 }" @click="change(3)"
          >FLOOR 3</a
        >
      </div>
    </div>
    <div class="relative">
      <transition mode="out-in" name="slide-fade">
        <vmap :config="this.floors[2]" v-if="this.selectedFloor == 2" />
      </transition>
      <transition mode="out-in" name="slide-fade">
        <vmap :config="this.floors[3]" v-if="this.selectedFloor == 3" />
      </transition>
    </div>
  </div>
</template>
<style scoped>
.floors a {
  margin: 0 27px;
}

.slide-fade-enter {
  transform: translateX(8rem);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-to {
  transform: translateX(-8rem);
  opacity: 0;
}
</style>
<script>
import vmap from "../components/Map";

export default {
  components: { vmap },
  name: "sharedServiceCenter",
  data() {
    return {
      selectedFloor: 3,
      floors: {
        2: require("../data/floor2.json"),
        3: require("../data/floor3.json")
      }
    };
  },
  methods: {
    change(index) {
      this.selectedFloor = index;
    }
  }
};
</script>
